import { h } from 'vue';
import vSelect from 'vue-select';
import SvgIcon from '@core/icons/SvgIcon.vue';
//import 'vue-select/dist/vue-select.css';

// Modify the components prop of vSelect
vSelect.props.components.default = () => ({
  Deselect: {
    render: () => h(SvgIcon, { icon: 'XIcon', size: 14 }),
  },
  OpenIndicator: {
    render: () => h(SvgIcon, { icon: 'ChevronDownIcon', size: 15, class: 'open-indicator' }),
  },
});

export default vSelect;
